import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Box,
  colors,
  Modal,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FaMapLocationDot } from "react-icons/fa6";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { FaBezierCurve } from "react-icons/fa";
import { FaBox } from "react-icons/fa";
import { GoSearch } from "react-icons/go";
import { InprogressDelivery } from "./InProgress/inprogressDeliveries";
import { ClosedDelivery } from "./closedDeliveries";
import { ReallotedDelivery } from "./reallotedDeliveries";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { toast, ToastContainer } from "react-toastify";

const columns = [
  // { id: "order_id", label: "ORDER ID", minWidth: 170, align: "center" },
  {
    id: "delivery_show_id",
    label: "DELIVERY ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: "pick_up_location",
    label: "PICKUPLOCATION",
    minWidth: 200,
    align: "center",
  },
  {
    id: "drop_location",
    label: "DROP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "vehicle_type",
    label: "VEHICLE TYPE ",
    minWidth: 130,
    align: "center",
  },
  { id: "actions", label: "ACTIONS", minWidth: 130, align: "center" },
];

function createData(
  // order_id,
  // ryder_id,
  delivery_show_id,
  pick_up_location,
  drop_location,
  // delivered_time
  // typeofpack,
  vehicle_type,
) {
  return {
    // order_id,
    // ryder_id,
    delivery_show_id,
    pick_up_location,
    drop_location,
    // delivered_time,
    // typeofpack,
    vehicle_type,
  };
}

const mockRyders = [
  { id: 1, name: "Ravi Kumar", contact: "9876543210" },
  { id: 2, name: "Anita Sharma", contact: "9123456789" },
  { id: 3, name: "Ajay Singh", contact: "9001122233" },
];

export function NewDelivery() {
  const [newDeliveryList, setNewDeliveryList] = useState([]);
  const [assignRyderList, setAssignRyderList] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [noRiderMessage, setNoRiderMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };
  const fetchUnDeliverys = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        // "/admin/deliveries/?pickup_status=pending"
        "/undelivered-orders/",
      );
      console.log("✅ undelivered orders list response:", res.data.data);
      console.log("🧪 Check keys in newDeliveryList[0]:", res.data.data[0]);
      if (res.data.status === "success") {
        const cleanedData = res.data.data.map((item) => ({
          // order_id: item["order_id "] ?? "--",
          delivery_show_id: item.delivery_show_id ?? "--",
          // orderitem_id: item.orderitem_id ?? "--",
          pick_up_location: item.pickup_location ?? "--",
          drop_location: item.delivery_location ?? "--",
          no_of_packs: item.no_of_packs ?? "--",
          vehicle_type: item.vehicle_type ?? "--",
          actions: "assign", // dummy for column match
        }));
        setNewDeliveryList(cleanedData);
      } else {
        setError("Failed to fetch undelivered orders  data.");
      }
    } catch (err) {
      console.error("❌ Error fetching undelivered orders  data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnDeliverys();
  }, []);

  // const handleCloseModal = () => setModalOpen(false);

  const handleCloseModal = () => {
    setModalOpen(false);
    setAssignRyderList([]);
    setNoRiderMessage("");
    setSelectedOrderId(null);
  };

  console.log(newDeliveryList);

  // const handleOpenModal = async (orderitem_id) => {
  //   setSelectedOrderId(orderitem_id);
  //   setModalOpen(true);

  //   try {
  //     const res = await axiosInstance.get(`/available-riders/${orderitem_id}`);
  //     if (res.data.status === "success") {
  //       setAssignRyderList(res.data.data.available_riders || []);
  //     } else {
  //       toast.error("Failed to load available riders.");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching available riders:", err);
  //     toast.error("Something went wrong while loading riders.");
  //   }
  // };
  const handleOpenModal = async (delivery_show_id) => {
    setSelectedOrderId(delivery_show_id);
    setModalOpen(true);
    setAssignRyderList([]);
    setNoRiderMessage("");

    try {
      const res = await axiosInstance.get(
        `/available-riders/${delivery_show_id}`,
      );

      if (res.data.status === "success") {
        if (res.data.data?.available_riders?.length > 0) {
          setAssignRyderList(res.data.data.available_riders);
          setNoRiderMessage("");
        } else {
          setNoRiderMessage(res.data.message || "No available riders found.");
        }
      } else {
        setNoRiderMessage("Failed to load available riders.");
      }
    } catch (err) {
      console.error("Error fetching available riders:", err);
      setNoRiderMessage("Something went wrong while loading riders.");
    }
  };

  const handleAssignRider = async (riderId) => {
    try {
      const res = await axiosInstance.post("/delivery-assigning/", {
        delivery_show_id: selectedOrderId,
        rider_id: riderId,
      });
      if (res.data.status === "success") {
        toast.success(res.data?.message || "Rider assigned successfully!");
        handleCloseModal();
        fetchUnDeliverys();
      } else {
        toast.error("Assignment failed.");
      }
    } catch (error) {
      console.error("Assignment error:", error);
      toast.error("Error assigning rider.");
    }
  };

  const filteredData = newDeliveryList.filter((row) => {
    const query = searchQuery.toLowerCase();

    // const orderIdStr = String(row.order_id ?? "").toLowerCase();
    const deliveryIdStr = String(row.delivery_show_id ?? "").toLowerCase();
    const pickupStr = String(row.pick_up_location ?? "").toLowerCase();
    const dropStr = String(row.drop_location ?? "").toLowerCase();

    return (
      // orderIdStr.includes(query) ||
      deliveryIdStr.includes(query) ||
      pickupStr.includes(query) ||
      dropStr.includes(query)
    );
  });

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("unassigned_page");
    return savedPage ? Number(savedPage) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = localStorage.getItem("unassigned_rowsPerPage");
    return savedRows ? Number(savedRows) : 20;
  });
  const pageChangedByUser = useRef(false);

  const handleChangePage = (event, newPage) => {
    pageChangedByUser.current = true;
    setPage(newPage);
    localStorage.setItem("unassigned_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);
    pageChangedByUser.current = true;

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("unassigned_rowsPerPage", value);
    localStorage.setItem("unassigned_page", 0);
  };

  // Reset page on search and filters

  useEffect(() => {
    if (loading) return;

    // Do NOT reset page on refresh
    if (!pageChangedByUser.current) return;

    const maxPage = Math.max(
      0,
      Math.ceil(filteredData.length / rowsPerPage) - 1,
    );

    if (page > maxPage) {
      setPage(0);
      localStorage.setItem("unassigned_page", 0);
    }
  }, [filteredData.length, rowsPerPage, loading, page]);

  return (
    <>
      <ToastContainer />
      <div>
        <div className="delivery-top-container">
          <div className="admin-listText">List of New Deliveries</div>
          {/* <div>
            <select
              className="listAdmin-showRecords"
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value={20}>Show No of Records</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
              <option value={2000}>2000</option>
              <option value={5000}>5000</option>
            </select>
          </div> */}
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="btnContainer">
          <button
            style={{
              // backgroundColor: "#FF961F",
              // color: "white",
              // display: "flex",
              backgroundColor: "#E8E8E9",
              color: "black",
              display: "flex",
            }}
            onClick={() => navigate("/out-for-delivery")}
          >
            <FaMapLocationDot style={{ marginRight: "8px" }} />
            Track Your Orders
          </button>
          <button
            // style={{ backgroundColor: "#34C759", color: "white" }}
            style={{ backgroundColor: "#1265c5", color: "white" }}
            onClick={() => navigate("/delivery")}
          >
            Unassigned
          </button>
          <button
            // style={{ backgroundColor: "#FF961F", color: "white" }}
            style={{ backgroundColor: "#E8E8E9" }}
            onClick={() => navigate("/inprogress-delivery")}
          >
            {/* In Process */}
            Re-Assign
          </button>
          <button
            style={{ backgroundColor: "#E8E8E9" }}
            onClick={() => navigate("/closed-delivery")}
          >
            Delivered
          </button>
          {/* <button
          style={{ backgroundColor: "#1265C5", color: "white" }}
          onClick={() => navigate("/realloted-delivery")}
        >
          ReAlloted
        </button> */}
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <Box sx={{ width: "100%", overflowX: "auto" }}>
            <TableContainer
              sx={{
                maxHeight: 640,
                minWidth: 1800,
                overflowX: "auto",
              }}
              className="Table-container"
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="table-header"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  ) : filteredData.length > 0 ? (
                    filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => (
                        <TableRow
                          className="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#E7F0F9" : "white",
                          }}
                        >
                          {columns.map((column) => {
                            const value = row[column.id] ?? "--";

                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={`${column.id}-column tableCelldata`}
                                onClick={
                                  column.id === "delivery_show_id"
                                    ? () =>
                                        navigate(
                                          `/view-deliveryId_wise-unassign/${row.delivery_show_id}`,
                                        )
                                    : undefined
                                }
                                sx={{
                                  cursor:
                                    column.id === "delivery_show_id"
                                      ? "pointer"
                                      : "default",
                                  color:
                                    column.id === "delivery_show_id"
                                      ? "#4184D1"
                                      : "",
                                }}
                              >
                                {column.id === "pick_up_location" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <IoMdRadioButtonOn
                                      style={{
                                        fontSize: "18px",
                                        color: "#34C759",
                                      }}
                                    />
                                    {value}
                                  </div>
                                ) : column.id === "drop_location" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <FaLocationDot
                                      style={{
                                        fontSize: "18px",
                                        color: "#F52D56",
                                      }}
                                    />
                                    {value}
                                  </div>
                                ) : column.id === "actions" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <button
                                      className="assignRyderbtn"
                                      onClick={() =>
                                        handleOpenModal(row.delivery_show_id)
                                      }
                                    >
                                      Assign Ryder
                                    </button>
                                  </div>
                                ) : // :
                                // column.id === "deliveredime" ? (
                                //   <div
                                //     style={{
                                //       display: "flex",
                                //       alignItems: "center",
                                //       gap: "8px",
                                //     }}
                                //   >
                                //     <IoMdTime
                                //       style={{
                                //         fontSize: "18px",
                                //         color: "#FF961F",
                                //       }}
                                //     />
                                //     <span
                                //       style={{
                                //         border: "1px solid rgb(168, 199, 231)",
                                //         padding: "5px",
                                //         borderRadius: "5px",
                                //       }}
                                //     >
                                //       {value}
                                //     </span>
                                //   </div>
                                // )
                                column.id === "vehicle_type" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    {value === "Bag" ? (
                                      <FaBezierCurve
                                        style={{
                                          fontSize: "18px",
                                          color: "#FF961F",
                                        }}
                                      />
                                    ) : (
                                      <FaBezierCurve
                                        style={{
                                          fontSize: "18px",
                                          color: "#FF961F",
                                        }}
                                      />
                                    )}
                                    {value}
                                  </div>
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns.length}
                        align="center"
                        style={{ padding: "40px 0" }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <TablePagination
            rowsPerPageOptions={[20, 50, 100, 500, 1000, 2000, 5000]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>

      {/* Modal for Available Ryders*/}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : 950,
            maxHeight: isMobile ? "90vh" : "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "4px",
            p: 2,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6">Available Ryders</Typography>
            <IconButton onClick={handleCloseModal}>❌</IconButton>
          </Box>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table-header">S.No</TableCell>
                    <TableCell className="table-header">Ryder Name</TableCell>
                    <TableCell className="table-header">
                      Contact Number
                    </TableCell>
                    <TableCell className="table-header">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {assignRyderList.length > 0 ? (
                    assignRyderList.map((ryder, idx) => (
                      <TableRow
                        className="table-row"
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={ryder.rider_id}
                        sx={{
                          backgroundColor: idx % 2 === 1 ? "#E7F0F9" : "white",
                        }}
                      >
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{ryder.name}</TableCell>
                        <TableCell>{ryder.mobile}</TableCell>
                        <TableCell>
                          {ryder.in_ride ? (
                            <button
                              disable
                              style={{
                                backgroundColor: "#babec1",
                                color: "white",
                                fontSize: "12px",
                                padding: "4px 8px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "not-allowed",
                              }}
                            >
                              In Ride
                            </button>
                          ) : (
                            <button
                              style={{
                                backgroundColor: "green",
                                color: "white",
                                fontSize: "12px",
                                padding: "4px 8px",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleAssignRider(ryder.rider_id)}
                            >
                              Assign
                            </button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No available riders found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Modal>
    </>
  );
}
